import { useState } from 'react'
import { CloseButton, Stack, Text } from '@backyard-ui/core'
import { AnimatePresence, motion } from 'framer-motion'

const Notification = () => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: '-50%' }}
          transition={{ duration: 0.3 }}
          className="w-full">
          <Stack
            align="center"
            spacing="2"
            justify="space-between"
            className="rounded-lg py-2 px-2 md:px-4 w-full bg-yellow-200"
            data-testid="chat-notification">
            <Text size="md" color="yellow-900">
              Esta conversa <strong>não está integrada com Whatsapp.</strong>
            </Text>

            <CloseButton
              size="xs"
              appearance="warning"
              variant="ghost"
              onClick={() => setIsVisible(false)}
            />
          </Stack>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Notification
